import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Button, Divider } from "@material-ui/core";

import { AuthContext } from "../../context/Auth/AuthContext";

const VcardPreview = ({ contact, numbers, email, org, title }) => {
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const cleanNumber = String(numbers || "").replace(/\D/g, "");

  const [selectedContact, setContact] = useState({
    id: null,
    name: "",
    number: "",
    profilePicUrl: ""
  });

  useEffect(() => {
    if (!cleanNumber) return;

    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const contactObj = {
            name: contact,
            number: cleanNumber,
            email: email || ""
          };

          const { data } = await api.post("/contact", contactObj);
          setContact(data);
        } catch (err) {
          toastError(err);
        }
      };

      fetchContacts();
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [contact, cleanNumber, email]);

  const handleNewChat = async () => {
    try {
      if (!selectedContact.id) return;

      const { data: ticket } = await api.post("/tickets", {
        contactId: selectedContact.id,
        userId: user.id,
        status: "open"
      });

      history.push(`/tickets/${ticket.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleAvatarError = async () => {
    try {
      if (!selectedContact?.id) return;

      await api.put(`/contactsupdate/${selectedContact.id}`, {
        ...selectedContact,
        profilePicUrl: "."
      });
    } catch (err) {}
  };

  const displayName = selectedContact.name || contact || "Contacto compartido";
  const displayNumber = numbers || selectedContact.number || "";
  const hasValidContact = !!selectedContact.id;

  return (
    <div style={{ minWidth: "250px" }}>
      <Grid container spacing={1}>
        <Grid item xs={2}>
          <Avatar
            src={selectedContact.profilePicUrl}
            imgProps={{
              onError: handleAvatarError
            }}
          />
        </Grid>

        <Grid item xs={9}>
          <Typography
            style={{ marginTop: "8px", marginLeft: "10px" }}
            variant="subtitle1"
            color="primary"
            gutterBottom
          >
            {displayName}
          </Typography>

          {!!displayNumber ? (
            <Typography
              style={{ marginLeft: "10px", marginTop: "-6px" }}
              variant="body2"
              color="textSecondary"
            >
              {displayNumber}
            </Typography>
          ) : (
            <Typography
              style={{ marginLeft: "10px", marginTop: "-6px" }}
              variant="body2"
              color="textSecondary"
            >
              Sin número disponible
            </Typography>
          )}

          {!!org && (
            <Typography
              style={{ marginLeft: "10px" }}
              variant="body2"
              color="textSecondary"
            >
              {org}
            </Typography>
          )}

          {!!title && (
            <Typography
              style={{ marginLeft: "10px" }}
              variant="body2"
              color="textSecondary"
            >
              {title}
            </Typography>
          )}

          {!!email && (
            <Typography
              style={{ marginLeft: "10px" }}
              variant="body2"
              color="textSecondary"
            >
              {email}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12}>
          <Divider />
          <Button
            fullWidth
            color="primary"
            onClick={handleNewChat}
            disabled={!hasValidContact}
          >
            Conversar
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default VcardPreview;




/*import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { AuthContext } from "../../context/Auth/AuthContext";

import { Button, Divider, } from "@material-ui/core";


const VcardPreview = ({ contact, numbers }) => {
    const history = useHistory();
    const { user } = useContext(AuthContext);

    const [selectedContact, setContact] = useState({
        name: "",
        number: 0,
        profilePicUrl: ""
    });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async() => {
                try {
                    let contactObj = {
                        name: contact,
                        number: numbers.replace(/\D/g, ""),
                        email: ""
                    }
                    const { data } = await api.post("/contact", contactObj);
					//console.log(data);
                    setContact(data)

                } catch (err) {
                    //console.log(err)
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [contact, numbers]);

    const handleNewChat = async() => {
        try {
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                userId: user.id,
                status: "open",
            });
            history.push(`/tickets/${ticket.id}`);
        } catch (err) {
            toastError(err);
        }
    }

    return (
		<>
			<div style={{
				minWidth: "250px",
			}}>
				<Grid container spacing={1}>
					<Grid item xs={2}>
						<Avatar src={selectedContact.profilePicUrl}
							imgProps={{
							onError: () => {
									contact.profilePicUrl = ".";
									api.put(`/contactsupdate/${contact.id}`, contact);
								},
							}}
							//onLoad: () => {},
						/>
					</Grid>
					<Grid item xs={9}>
						<Typography style={{ marginTop: "12px", marginLeft: "10px" }} variant="subtitle1" color="primary" gutterBottom>
							{selectedContact.name}
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<Divider />
						<Button
							fullWidth
							color="primary"
							onClick={handleNewChat}
							disabled={!selectedContact.number}
						>Conversar</Button>
					</Grid>
				</Grid>
			</div>
		</>
	);

};

 export default VcardPreview;*/